var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var RestrictInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    var self = this;

    ShapeWrapperInteractionView.apply(this, arguments);

    this.registerPatterns(editorView);
};
lib_core.inherit(RestrictInteractionView, ShapeWrapperInteractionView);

module.exports = RestrictInteractionView;

RestrictInteractionView.prototype.registerPatterns = function (editorView) {
    var size = 600;
    var defs;
``
    if(!$("#copperHatch").length > 0) {
        if (!defs) defs = editorView.svg.defs();

        var copperPattern = editorView.svg.pattern("copperHatch", 0, 0, size, size);
        copperPattern.setAttribute('patternUnits', 'userSpaceOnUse');
        copperPattern.setAttribute('patternTransform', 'rotate(-45, 0, 0)');
        var path_attrs = {
            'stroke-width': '50',
            'stroke': 'red',
        };
        var path = editorView.svg.line(null, 0, 0, 0, size, path_attrs);
        $(copperPattern).append(path);

        $(defs).append(copperPattern);
    }

    if(!$("#componentHatch").length > 0) {
        if (!defs) defs = editorView.svg.defs();

        var componentPattern = editorView.svg.pattern("componentHatch", 0, 0, size, size);
        componentPattern.setAttribute('patternUnits', 'userSpaceOnUse');
        componentPattern.setAttribute('patternTransform', 'rotate(45, 0, 0)');
        path_attrs = {
            'stroke-width': '50',
            'stroke': 'yellow',
        };
        path = editorView.svg.line(null, 0, 0, 0, size, path_attrs);
        $(componentPattern).append(path);

        $(defs).append(componentPattern);
    }

    if(!$("#viaHatch").length > 0) {
        if (!defs) defs = editorView.svg.defs();

        var viaPattern = editorView.svg.pattern("viaHatch", 0, 0, size, size);
        viaPattern.setAttribute('patternUnits', 'userSpaceOnUse');
        path_attrs = {
            'stroke-width': '50',
            'stroke': 'cyan',
        };
        path = editorView.svg.line(null, 0, 0, 0, size, path_attrs);
        $(viaPattern).append(path);

        $(defs).append(viaPattern);
    }
}

RestrictInteractionView.prototype.getAttributes = function () {
    var color;
    var hatch;

    switch (this.data.parent().parentCollection[0].getName()) {
        case "componentRestricts":
            color = "yellow";
            hatch = "componentHatch";
            break;
        case "copperRestricts":
            color = "red";
            hatch = "copperHatch";
            break;
        case "viaRestricts":
            color = "cyan";
            hatch = "viaHatch";
            break;
    }

    var strokeWidth = 75;
    var attrs = {
        "stroke": color,
        "stroke-width": strokeWidth,
        "stroke-dasharray": [8*strokeWidth, 4*strokeWidth],
        "fill": "url(#"+hatch+")"
    };

    return attrs;
};

RestrictInteractionView.prototype.getLayers = function () {
    var self = this;

    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(0) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP))) {
        console.assert(this.layers.restrictTop && this.layers.restrictTopControl, "Missing layers");

        return {
            draw: this.layers.restrictTop,
            control: this.layers.restrictTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(onInnerLayerAndVisible()) {
        console.assert(this.layers.restrictInner && this.layers.restrictInnerControl, "Missing layers");

        return {
            draw: this.layers.restrictInner,
            control: this.layers.restrictInnerControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(1) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM))){
        console.assert(this.layers.restrictBottom && this.layers.restrictBottomControl, "Missing layers");

        return {
            draw: this.layers.restrictBottom,
            control: this.layers.restrictBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }

    function onInnerLayerAndVisible() {
        var answer

        self.editorModel.visibleLayers.forEach(function(layer) {
            if(layer < 2 || layer == cio_datamodel.FootprintLayers.TOP || layer == cio_datamodel.FootprintLayers.Bottom) return;

            if(self.data.layerIndex.contains(layer)) answer = true;
        })

        return answer;
    }
}